import { useQuery } from "@apollo/client/react";
import { type FC, type ReactNode, useCallback } from "react";
import { graphql } from "src/gql/graphql";
import { NotificationContext, type NotificationData } from "./context";

const Query = graphql(
  `
  query NotificationProvider {
    currentUser {
      currentWorkspace {
        transcripts(unprocessed: true) {
          totalCount
        }
      }
    }
  }
  `,
);

export const NotificationProvider: FC<{
  children: ReactNode;
}> = ({ children }) => {
  const result = useQuery(Query, { fetchPolicy: "network-only" });

  const unprocessedTranscripts =
    result.data?.currentUser?.currentWorkspace?.transcripts;

  const data: NotificationData = unprocessedTranscripts
    ? {
        loading: false,
        recentUnprocessedTranscripts: {
          totalCount: unprocessedTranscripts.totalCount,
        },
      }
    : {
        loading: true,
      };

  const refetch = useCallback(() => {
    result.refetch();
  }, [result.refetch]);

  return (
    <NotificationContext.Provider
      value={{
        data,
        refetch,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};
